(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-section"] && !Shopify.designMode) return;
  try {
    
  const compresion_block = document.getElementById('comparison-table-w');
  const compresion_scrollText = document.getElementById('scroll_text');

  if (compresion_block && compresion_scrollText) {
    window.addEventListener('load', onLoadFunction);
    window.addEventListener('resize', onLoadFunction);
  }

  function onLoadFunction(e) {
    if (!compresion_block || !compresion_scrollText) return;
    let compresion_isHorizontalScroll = compresion_block.scrollWidth > compresion_block.clientWidth;
    compresion_isHorizontalScroll
      ? compresion_scrollText.classList.add('scroll-on')
      : compresion_scrollText.classList.remove('scroll-on');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contactus"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const contactForm = document.querySelector('#ContactForm');
    if (!contactForm) return;

    const nameInput = contactForm.querySelector('input[name="contact[name]"]');
    const emailInput = contactForm.querySelector('input[name="contact[email]"]');
    const submitBtn = contactForm.querySelector('.submit-button');

    if (!nameInput || !emailInput || !submitBtn) return;

    // Initially disable submit
    submitBtn.disabled = true;

    const validateForm = () => {
      const nameValid = nameInput.value.trim().length > 0;
      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
      submitBtn.disabled = !(nameValid && emailValid);
    };

    // Listen for input changes
    nameInput.addEventListener('input', validateForm);
    emailInput.addEventListener('input', validateForm);

    // Optionally, prevent submission if JS disabled somehow
    contactForm.addEventListener('submit', (e) => {
      if (submitBtn.disabled) e.preventDefault();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Prevent binding multiple times across section re-renders
    if (window.__featuredProductsAddToCartBound) return;
    window.__featuredProductsAddToCartBound = true;
    const shouldRedirectToCartPage = () => window.themeCartSettings?.addBehavior === 'page';

    document.addEventListener('click', async (e) => {
      const btn = e.target?.closest?.('[data-featured-products-add-to-cart]');
      if (!btn) return;

      // Safety: never submit any underlying form/card click handlers
      e.preventDefault();
      e.stopPropagation();

      if (btn.classList.contains('is-soldout') || btn.classList.contains('btn--soldout') || btn.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const variantId = btn.dataset?.variantId;
      if (!variantId) return;

      const quantity = typeof window.getCollectionCardQty === 'function' ? window.getCollectionCardQty(btn) : 1;

      // Basic UX
      const prevAriaDisabled = btn.getAttribute('aria-disabled');
      const prevPointerEvents = btn.style.pointerEvents;
      btn.setAttribute('aria-disabled', 'true');
      btn.style.pointerEvents = 'none';

      try {
        if (window.VanillaCartState?.addItem) {
          await window.VanillaCartState.addItem(variantId, quantity);
        } else {
          // Fallback if state manager isn't ready yet
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity })
          });
        }

        if (shouldRedirectToCartPage()) {
          window.location.href = window.routes?.cart_url || '/cart';
        } else if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else {
          const cartSlide = document.querySelector('cart-slide');
          cartSlide?.toggleCart?.();
        }
      } catch (err) {
        // Don't reload the page; just log the error
        console.error('Featured products add-to-cart error:', err);
      } finally {
        if (prevAriaDisabled === null) btn.removeAttribute('aria-disabled');
        else btn.setAttribute('aria-disabled', prevAriaDisabled);
        btn.style.pointerEvents = prevPointerEvents;
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyBlock extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (!this.dataset.refBlock && !this.dataset.behavior) return;
      const stickyHide = () => {
        this.setAttribute('data-revealed', false);
        if (this.dataset.hasHidden === 'true') this.setAttribute('aria-hidden', true);
        if (this.dataset.bodyClass) document.body.classList.remove(this.dataset.bodyClass);
        if (this.height) {
          this.style.removeProperty('height');
          if (this.dataset.bodyClass) document.body.style.removeProperty('--page-header-height');
        }
      };
      const initialize = () => {
        this.behavior = this.dataset.behavior;
        this.spacer = this.dataset.spacer;
        this.endBounds = document.body.offsetHeight + this.offsetHeight;
        if (this.behavior) {
          switch (this.behavior) {
            case 'downwards':
              window.addEventListener('scroll', onDownwardScroll.bind(this));
              break;
            case 'upwards':
              window.addEventListener('scroll', onUpwardScroll.bind(this));
              break;
            case 'stacked':
              window.addEventListener('scroll', onStackedScroll.bind(this));
              break;
            case 'observer':
              window.addEventListener('scroll', onObservedScroll.bind(this));
              break;
            default:
              break;
          }
        }
        this.refBlock = document.querySelector(this.dataset.refBlock);
        if (!this.refBlock) return;
        this.refBoundings = this.refBlock.getBoundingClientRect();
        this.offset = this.dataset.offset ? parseFloat(this.dataset.offset) : 0;
        this.threshold = this.refBlock.offsetTop + this.refBoundings.height + this.offset;
        this.previousScrollAmount = window.screenY;
        this.percent = this.dataset.pagePercentage ? this.dataset.pagePercentage : null;
        if (this.spacer) this.height = this.refBlock.offsetHeight;
      };
      const onObservedScroll = () => {
        let revealedAttr = true;
        const handleObserver = (entries, observer) => {
          observer.unobserve(this);
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              revealedAttr = false;
            } else {
              revealedAttr = true;
            }
            setStickyStatus(revealedAttr);
          });
        };
        new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
      };
      const onDownwardScroll = () => {
        let revealedAttr = false;
        if (this.percent) {
          const pageHeight = document.documentElement.offsetHeight;
          const threshold = (pageHeight * parseFloat(this.percent)) / 100;
          this.threshold = threshold;
        }
        if (window.scrollY > this.threshold) revealedAttr = true;
        setStickyStatus(revealedAttr);
      };
      const onUpwardScroll = () => {
        let revealedAttr = false;
        const threshold = this.height ? this.height : this.refBlock.offsetHeight;

        if (window.scrollY > this.previousScrollAmount) {
          revealedAttr = false;
        } else if (window.scrollY < this.previousScrollAmount) {
          revealedAttr = true;
          if (window.scrollY < threshold) revealedAttr = false;
        }
        setStickyStatus(revealedAttr);
        this.previousScrollAmount = window.scrollY;
      };
      const onStackedScroll = () => {
        let revealedAttr = false;
        if (this.refBoundings.y < 0) this.refBoundings.y += window.scrollY;
        if (this.refBoundings.y < window.scrollY) revealedAttr = true;
        setStickyStatus(revealedAttr);
      };
      const setStickyStatus = (revealed) => {
        if (this.dataset.hideOnEnd === 'true')
          if (window.innerHeight + window.scrollY >= this.endBounds) return stickyHide();
        if (revealed) {
          this.setAttribute('data-revealed', true);
          if (this.dataset.hasHidden === 'true') this.removeAttribute('aria-hidden');
          if (this.dataset.bodyClass) document.body.classList.add(this.dataset.bodyClass);
          if (this.height) {
            this.style.height = this.height + 'px';
            if (this.dataset.bodyClass) document.body.style.setProperty('--page-header-height', this.height + 'px');
          }
          return;
        }
        stickyHide();
      };
      const setTempoStatus = (flag, refContainer) => {
        const refElement = document.querySelector(refContainer);
        if (!refElement) return;
        refElement.style.transform = flag ? 'translateY(0%)' : 'translateY(-100%)';
      };
      this.setTempoStatus = setTempoStatus;
      this.setStickyStatus = setStickyStatus;
      this.initLoad = setTimeout(initialize.bind(this), 100);
      document.addEventListener('DOMContentLoaded', function () {
        this.initLoad;
      });
    }
  }
  if (!customElements.get('sticky-block')) {
    customElements.define('sticky-block', StickyBlock);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const announcementBars = document.querySelectorAll('.announcement-bar');
    const countdownBars = document.querySelectorAll('.countdown-bar');
    const pageHeader = document.querySelector('.page-header');
    if (!announcementBars.length && !countdownBars.length && !pageHeader) return;

    let scheduled = false;
    const updateHeaderHeight = () => {
      let totalHeight = 0;
      announcementBars.forEach((bar) => {
        totalHeight += bar.offsetHeight || 0;
      });
      countdownBars.forEach((bar) => {
        totalHeight += bar.offsetHeight || 0;
      });
      if (pageHeader) {
        totalHeight += pageHeader.offsetHeight || 0;
      }
      document.body.style.setProperty('--header-total-height', `${totalHeight}px`);
    };
    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        updateHeaderHeight();
      });
    };

    updateHeaderHeight();
    window.addEventListener('resize', scheduleUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(scheduleUpdate);
      announcementBars.forEach((bar) => ro.observe(bar));
      countdownBars.forEach((bar) => ro.observe(bar));
      if (pageHeader) ro.observe(pageHeader);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  const setMcpgStickyTop = () => {
    const header =
      document.querySelector('.page-header_fixed-area') ||
      document.querySelector('.header') ||
      document.getElementById('shopify-section-header');
    const headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    const top = Math.max(20, headerHeight + 20);
    document.documentElement.style.setProperty('--mcpg-sticky-top', `${top}px`);
  };
  setMcpgStickyTop();
  window.addEventListener('resize', setMcpgStickyTop);

  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) return new URLSearchParams(url.searchParams).toString();
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach((key) => key.includes('filter.v.price') && url.searchParams.delete(key));
        } else {
          if (!value) {
            url.searchParams.delete(param);
          } else {
            const valToDel = value;
            const values = url.searchParams.getAll(param);
            const updatedValues = values.filter((value) => value !== valToDel);
            url.searchParams.delete(param);
            updatedValues.forEach((value) => url.searchParams.append(param, value));
          }
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach((key) => key.includes('filter') && url.searchParams.delete(key));
        break;

      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }

    input.value = url.toString();
  };
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const initCollectionSwatches = () => {
    if (window.__mcpgSwatchClickBound) return;
    window.__mcpgSwatchClickBound = true;
    const swatchImageCache = new Set();

    const preloadSwatchImage = (url) => {
      if (!url || swatchImageCache.has(url)) return;
      swatchImageCache.add(url);
      const image = new Image();
      image.src = url;
    };

    document.querySelectorAll('.collection-swatch-dot[data-variant-image]').forEach((btn) => {
      preloadSwatchImage(btn.dataset.variantImage);
    });

    document.addEventListener(
      'mouseover',
      (event) => {
        const swatchButton = event.target.closest('.collection-swatch-dot');
        if (!swatchButton) return;
        preloadSwatchImage(swatchButton.dataset.variantImage);
      },
      true
    );

    document.addEventListener('click', (event) => {
      const swatchButton = event.target.closest('.collection-swatch-dot');
      if (!swatchButton) return;
      if (swatchButton.closest('.complete-the-look')) return;
      // Price / active state / ATC are handled by collection-quick-add.js.
      // This only applies an image fallback when variant media is missing.

      let nextImage = swatchButton.dataset.variantImage;
      if (!nextImage) {
        const circle = swatchButton.querySelector('.collection-swatch-circle');
        if (circle) {
          const bg = window.getComputedStyle(circle).backgroundImage;
          if (bg && bg !== 'none') {
            nextImage = bg.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
          }
        }
      }
      if (!nextImage) return;

      const productItem = swatchButton.closest('.product-item');
      const primaryImage = productItem ? productItem.querySelector('.primary-image') : null;
      if (!primaryImage) return;
      if (primaryImage.currentSrc === nextImage || primaryImage.src === nextImage) return;

      primaryImage.src = nextImage;
      primaryImage.removeAttribute('srcset');
    });
  };
  initCollectionSwatches();
  class FiltersDropdown extends HTMLElement {
    constructor() {
      super();

      this.isSidebar = this.dataset.mode === 'sidebar';
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.querySelectorAll('input');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (this.isSidebar) return;
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      if (this.isSidebar) {
        this.initFilters();
        return;
      }
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        this.initFilters();
        if (this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        closeDetailsTag();
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.fields.forEach((field) => {
          field.removeEventListener('input', this.debouncedOnSubmit.bind(this));
        });
        if (this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const closeDetailsTag = () => {
        const tags = this.querySelectorAll('details');
        tags.forEach((tag) => {
          tag.removeAttribute('open');
        });
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }

    initFilters() {
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 300);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach((field) => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const target = event.target;
      switch (target.type) {
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
          setFilterParam(target.name, target.value);
          break;
        default:
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
  }
  if (!customElements.get('filters-dropdown')) {
    customElements.define('filters-dropdown', FiltersDropdown);
  }

  class FiltersSidebar extends HTMLElement {
    connectedCallback() {
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 300);
      this.onInput = this.debouncedOnSubmit.bind(this);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach((field) => {
        field.addEventListener('input', this.onInput);
      });
    }

    disconnectedCallback() {
      if (!this.fields) return;
      this.fields.forEach((field) => {
        field.removeEventListener('input', this.onInput);
      });
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const target = event.target;
      switch (target.type) {
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
          setFilterParam(target.name, target.value);
          break;
        default:
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter?.onSubmitHandler?.(target.id);
    }
  }

  if (!customElements.get('filters-sidebar')) {
    customElements.define('filters-sidebar', FiltersSidebar);
  }
  class SortDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content.querySelectorAll('[data-btn-sort]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const setCurrentValue = (target) => {
        const elem = self.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        self.closeDropdown();
      };
      const onSortSelect = (event) => {
        const target = event.target;
        self.items.forEach((item) =>
          item.classList.remove('main-featured-product-grid_facets-sort-action-btn--active')
        );
        target.classList.add('main-featured-product-grid_facets-sort-action-btn--active');
        setCurrentValue(target);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        self.items.forEach((item) => {
          item.addEventListener('click', self.sortSelect);
        });
        if (this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.items.forEach((item) => {
          item.removeEventListener('click', self.sortSelect);
        });
        if (this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.sortSelect = onSortSelect.bind(this);
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('sort-dropdown')) {
    customElements.define('sort-dropdown', SortDropdown);
  }

  class FacetRemoveButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      this.button.addEventListener('click', (event) => {
        event.preventDefault();

        const { name, value, valueArr } = this.dataset;
        const values = valueArr || value || null;

        setFilterParam(name === 'all' ? null : name, values, name === 'all' ? 'all' : true);

        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter?.onSubmitHandler?.();
      });
    }
  }

  if (!customElements.get('facet-remove-button')) customElements.define('facet-remove-button', FacetRemoveButton);

  (function () {
    // Prevent binding multiple times across section re-renders
    if (window.__mainCollectionGridAddToCartBound) return;
    window.__mainCollectionGridAddToCartBound = true;
    const shouldRedirectToCartPage = () => window.themeCartSettings?.addBehavior === 'page';

    document.addEventListener('click', async (e) => {
      const btn = e.target?.closest?.('[data-main-collection-grid-add-to-cart]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset?.variantId;
      if (!variantId) return;

      const quantity = typeof window.getCollectionCardQty === 'function' ? window.getCollectionCardQty(btn) : 1;

      const prevAriaDisabled = btn.getAttribute('aria-disabled');
      const prevPointerEvents = btn.style.pointerEvents;
      btn.setAttribute('aria-disabled', 'true');
      btn.style.pointerEvents = 'none';

      try {
        if (window.VanillaCartState?.addItem) {
          await window.VanillaCartState.addItem(variantId, quantity);
        } else {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity })
          });
        }

        if (shouldRedirectToCartPage()) {
          window.location.href = window.routes?.cart_url || '/cart';
        } else if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else {
          const cartSlide = document.querySelector('cart-slide');
          cartSlide?.toggleCart?.();
        }
      } catch (err) {
        console.error('Main collection grid add-to-cart error:', err);
      } finally {
        if (prevAriaDisabled === null) btn.removeAttribute('aria-disabled');
        else btn.setAttribute('aria-disabled', prevAriaDisabled);
        btn.style.pointerEvents = prevPointerEvents;
      }
    }, true);
  })();

  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback() {
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event) {
      if (event.state && this.cachedResults.length === 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }

      if (this.cachedResults && this.cachedResults.length > 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = { params: searchParams };
        if (this.cachedResults.some((key) => key.params === term.params))
          return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target) {
      toggleLoader(true);
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if (!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = { params: searchParams };
      if (this.cachedResults.length > 0 && this.cachedResults.some((key) => key.params === term.params)) {
        this.renderFromCache(this.cachedResults, term, true, target);
        return;
      }
      this.renderFetch(url, true, searchParams, target);
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null) {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach((section) => {
            const html = new DOMParser().parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach((selector) => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.outerHTML = sourceElement.outerHTML;
              }
            });
          });
          const cacheObj = { params: searchParams, content: data };
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          if (updateURLHash) this.updateURLHash(searchParams);
          const filtersDropdown = document.querySelector('filters-dropdown');
          // Only toggle filter drawer if it's already open (to close it), not when sorting
          if (filtersDropdown && filtersDropdown.button && filtersDropdown.button.getAttribute('aria-expanded') === 'true') {
            filtersDropdown.button.dispatchEvent(new Event('click'));
          }
          if (target) this.handleDropdown(target);
          toggleLoader(false);
        });
    }

    handleDropdown(target) {
      const org = document.getElementById(target);
      const dropdown = org.closest('details');
      dropdown.setAttribute('open', '');
      org.focus();
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null) {
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find((results) => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach((section) => {
        const html = new DOMParser()
          .parseFromString(cachedResults.content[section.id], 'text/html')
          .getElementById(section.id);
        section.selectors.forEach((selector) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.outerHTML = sourceElement.outerHTML;
          }
        });
      });
      if (updateURLHash) this.updateURLHash(filter.params);
      toggleLoader(false);
    }

    updateURLHash(searchParams) {
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`
      );
    }
  }
  if (!customElements.get('grid-load-more')) {
    customElements.define(
      'grid-load-more',
      class GridLoadMore extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
          this.loader = this.querySelector('[data-loader]');
          this.requested = false;
          this.infiniteObserver = null;
          this.scrollHandler = null;
        }

        connectedCallback() {
          if (!this.button) return;
          this.bindEvents();
        }

        disconnectedCallback() {
          if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler);
            this.scrollHandler = null;
          }
          if (this.infiniteObserver) {
            this.infiniteObserver.disconnect();
            this.infiniteObserver = null;
          }
        }

        bindEvents() {
          this.button.addEventListener('click', this.onLoadMore.bind(this));

          if (this.dataset.infinite === 'true') {
            this.requested = false;
            this.scrollHandler = this.onInfiniteScroll.bind(this);
            window.addEventListener('scroll', this.scrollHandler);
            this.onInfiniteScroll();
          }
        }

        onInfiniteScroll() {
          if (this.infiniteObserver) return;
          this.infiniteObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                  this.requested = false;
                  return;
                }
                if (this.requested) return;
                this.button.dispatchEvent(new Event('click'));
                this.requested = true;
              });
            },
            { rootMargin: '0px 0px -60px 0px' }
          );
          this.infiniteObserver.observe(this);
        }

        onLoadMore(event) {
          event.preventDefault();
          this.button.classList.add('disabled');
          if (this.loader) this.loader.classList.remove('hidden');
          if (typeof toggleLoader === 'function') toggleLoader(true);
          this.showButton = true;

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = text;

              const columns = tempDiv.querySelectorAll('[data-render-columns]');
              const paginationWrapper = this.closest('[data-paging-loader-parent]');
              const gridRoot = paginationWrapper?.closest('[data-render-grid]');
              const productsGrid = gridRoot?.querySelector('.products-grid');
              const sectionId = paginationWrapper?.dataset.sectionId;
              const newPagination = sectionId
                ? tempDiv.querySelector(`[data-paging-loader-parent][data-section-id="${sectionId}"]`)
                : tempDiv.querySelector('[data-paging-loader-parent]');

              if (!paginationWrapper || !productsGrid) {
                this.showButton = false;
                return;
              }

              columns.forEach((column) => {
                productsGrid.appendChild(column);
                const atcBtn = column.querySelector('atc-submit-form');
                if (atcBtn && typeof atcBtn.initialize === 'function') atcBtn.initialize();
                const variantChanger = column.querySelector('single-variant');
                if (variantChanger && typeof variantChanger.initialize === 'function') variantChanger.initialize();
              });

              if (newPagination) {
                paginationWrapper.innerHTML = newPagination.innerHTML;
              } else {
                this.showButton = false;
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              if (!this.showButton) {
                const parent = this.parentElement;
                if (parent) parent.style.display = 'none';
              } else {
                this.button.classList.remove('disabled');
                if (this.loader) this.loader.classList.add('hidden');
                this.requested = false;
              }

              if (typeof toggleLoader === 'function') toggleLoader(false);
            });
        }
      }
    );
  }

  if (!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search-results"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
  };
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) return new URLSearchParams(url.searchParams).toString();
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach(key =>
            key.includes('filter.v.price') && url.searchParams.delete(key)
          );
        } else {
          if(!value){
            url.searchParams.delete(param);
          } else{
            const valToDel = value;
            const values = url.searchParams.getAll(param);
            const updatedValues = values.filter(value => value !== valToDel);
            url.searchParams.delete(param);
            updatedValues.forEach(value => url.searchParams.append(param, value));
          }
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach(key =>
          key.includes('filter') && url.searchParams.delete(key)
        );
        break;

      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }

    input.value = url.toString();
  };
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if(!loader) return;
    if(state){
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease'
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease'
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  class FiltersDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.querySelectorAll('input');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)){
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        this.initFilters();
        if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        closeDetailsTag();
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.fields.forEach(field => {
          field.removeEventListener('input', this.debouncedOnSubmit.bind(this));
        });
        if(this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          target === self.button && self.button.getAttribute('aria-expanded') === 'true'
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const closeDetailsTag = () => {
        const tags = this.querySelectorAll('details');
        tags.forEach(tag => {
          tag.removeAttribute('open');
        });
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }

    initFilters(){
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach(field => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }

    onSubmitHandler(event){
      event.preventDefault();
      const target = event.target;
      switch(target.type){
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
          setFilterParam(target.name, target.value);
          break;
        default:
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
  }
  if (!customElements.get('filters-dropdown')) { customElements.define('filters-dropdown', FiltersDropdown); }
  class SortDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content.querySelectorAll('[data-btn-sort]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const setCurrentValue = (target) => {
        const elem = self.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        self.closeDropdown();
      }
      const onSortSelect = (event) => {
        const target = event.target;
        self.items.forEach(item => item.classList.remove('main-featured-product-grid_facets-sort-action-btn--active'));
        target.classList.add('main-featured-product-grid_facets-sort-action-btn--active');
        setCurrentValue(target);
      }
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)){
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        self.items.forEach(item => {item.addEventListener('click', self.sortSelect);});
        if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if(self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.items.forEach(item => {item.removeEventListener('click', self.sortSelect);});
        if(this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          target === self.button && self.button.getAttribute('aria-expanded') === 'true'
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.sortSelect = onSortSelect.bind(this);
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('sort-dropdown')) { customElements.define('sort-dropdown', SortDropdown); }
  
  class FacetRemoveButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      this.button.addEventListener('click', (event) => {
        event.preventDefault();

        const { name, value, valueArr } = this.dataset;
        const values = valueArr || value || null;

        setFilterParam(name === 'all' ? null : name, values, name === 'all' ? 'all' : true);

        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter?.onSubmitHandler?.();
      });
    }
  }

  if (!customElements.get('facet-remove-button'))
    customElements.define('facet-remove-button', FacetRemoveButton);


  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback(){
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event){
      if(event.state && this.cachedResults.length === 0){
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }
      
      if(this.cachedResults && this.cachedResults.length > 0){
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = {params: searchParams};
        if (this.cachedResults.some(key => key.params === term.params)) return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target){
      toggleLoader(true);
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if(!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = {params: searchParams};
      if(this.cachedResults.length > 0 && this.cachedResults.some(key => key.params === term.params)){
        this.renderFromCache(this.cachedResults, term, true, target);
        return;
      }
      this.renderFetch(url, true, searchParams, target);
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null){
      fetch(url)
        .then(response => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach(section => {
            const html = new DOMParser() .parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach(selector => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.outerHTML = sourceElement.outerHTML;
              }
            });
          });
          const cacheObj = {params: searchParams, content: data};
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          if(updateURLHash) this.updateURLHash(searchParams);
          if(target){
            const org = document.getElementById(target);
            if(org) org.focus();
          }
          toggleLoader(false);
        }
      );
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null){
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find(results => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach(section => {
        const html = new DOMParser() .parseFromString(cachedResults.content[section.id], 'text/html').getElementById(section.id);
        section.selectors.forEach(selector => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.outerHTML = sourceElement.outerHTML;
          }
        });
      });
      if(updateURLHash) this.updateURLHash(filter.params);
      toggleLoader(false);
    }

    updateURLHash(searchParams){
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState({ searchParams }, '', `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`);
    }
  }
  if(!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__featuredProductsAddToCartBound) return;
    window.__featuredProductsAddToCartBound = true;

    document.addEventListener('click', async (e) => {
      const btn = e.target?.closest?.('[data-featured-products-add-to-cart]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (btn.classList.contains('is-soldout') || btn.classList.contains('btn--soldout') || btn.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const variantId = btn.dataset?.variantId;
      if (!variantId) return;

      const quantity = typeof window.getCollectionCardQty === 'function' ? window.getCollectionCardQty(btn) : 1;

      const prevAriaDisabled = btn.getAttribute('aria-disabled');
      const prevPointerEvents = btn.style.pointerEvents;
      btn.setAttribute('aria-disabled', 'true');
      btn.style.pointerEvents = 'none';

      try {
        if (window.VanillaCartState?.addItem) {
          await window.VanillaCartState.addItem(variantId, quantity);
        } else {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity })
          });
        }

        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else {
          const cartSlide = document.querySelector('cart-slide');
          cartSlide?.toggleCart?.();
        }
      } catch (err) {
        console.error('Featured products add-to-cart error:', err);
      } finally {
        if (prevAriaDisabled === null) btn.removeAttribute('aria-disabled');
        else btn.setAttribute('aria-disabled', prevAriaDisabled);
        btn.style.pointerEvents = prevPointerEvents;
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
